module.exports = "img/flags/AU.e8df0e1.png";